import { LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';

//
// base class for simple API response based <select>s
//
export class TefComsBaseSelect extends LitElement {
  @property({ type: String }) selected: string;
  @query('select', true) select$!: HTMLSelectElement;

  async api<T>(path: string): Promise<T> {
    const response = await fetch(`${this.apiBaseUrl}/${path}`, {
      headers: { Authorization: 'Basic dGVzdDpzZWNyZXQ=' },
    });

    if (!response.ok) {
      throw new Error(`Could not fetch data from ${response.url}: ${response.statusText}`);
    }

    return await response.json() as T;
  }

  get apiBaseUrl() {
    const { hostname } = window.location;

    if (hostname === 'localhost') {
      return 'http://localhost:3000';
    }

    const match = /^(?<environment>.*?)-micro-frontend-proxy/.exec(hostname);
    if (match) {
      return `https://${match.groups!.environment}-api-consent.high.coms-dev.aws.de.pri.o2.com`;
    }

    throw new Error(`Could not detect environment from hostname=${hostname}`);
  }

  // Render to lightDOM
  createRenderRoot() {
    return this;
  }
}
